import react from './techstack/reactNew.gif'
import nodejs from './techstack/nodejs.png'
import express from './techstack/express.png'
import mongodb from './techstack/MongoDB.gif'
import js from './techstack/javascript.gif'
import html from './techstack/html.gif'
import css from './techstack/css3.png'
import wind from './techstack/wind.png'
import git from './techstack/git.png'
import postman from './techstack/postman.png'
import chatgpt from './techstack/chatgpt.png'
import spotify from './techstack/spotify-logo.png'


const images =[
    {
      "title": "react",
      "url": react,
      "color":"bg-white"
    },
    {
      "title": "nodejs",
      "url": nodejs,
      "color":"bg-blue-400"
    },
    {
      "title": "expressjs",
      "url": express,
      "color":"bg-purple-400"
    },
    {
      "title": "mongoDB",
      "url": mongodb,
      "color":"bg-white"
    },
    {
      "title": "Javascript",
      "url": js,
      "color":"bg-white"
    },
    {
      "title": "HTML",
      "url": html,
      "color":"bg-white"
    },
    {
      "title": "CSS",
      "url": css,
      "color":"bg-purple-400"
    },
    {
      "title": "tailwindCss",
      "url": wind,
      "color":"bg-red-700"
    },
    {
      "title": "github",
      "url": git,
      "color":"bg-black"
    },
    {
      "title": "postman",
      "url": postman,
      "color":"bg-black"
    },
    {
      "title": "chatGPT",
      "url": chatgpt,
      "color":"bg-red-700"
    },
    {
      "title": "spotify",
      "url": spotify, 
      "color":"bg-green-400"
    }
  ]

  export default images